<template>
    <div>
        <navbar></navbar>
        <img src="../assets/img/findworka-talents.png" class="__climgrtl"/>
        <div class="container">
            <p class="__portpnew">Scaling Pillar’s Fintech Vision with Elite African Engineering Talent</p>
            <p class="__headin">The Challenge</p>
            <p class="__meetdname">Pillar set out to help immigrants in the UK monitor and build their credit scores — but they needed reliable, top-tier engineering talent fast. Traditional recruiting cycles were too slow and too costly for a fast-moving fintech.</p>
            
            <p class="__headin">The Solution</p>
            <p class="__meetdname">Findworka deployed three “rockstar” engineers who plugged directly into Pillar’s product teams:</p>
            <ul class="__portp2new">
                <li><b class="__namp">Node.js Backend Developer – </b>Optimised authentication flows and integrated third-party credit-monitoring APIs.</li>
                <li><b class="__namp">Flutter Mobile Developer – </b> Shipped consistent Android & iOS releases, slashing crash rates and boosting retention.</li>
                <li><b class="__namp">QA Engineer – </b> Introduced automated test suites and smart regression testing to keep every release airtight.</li>
            </ul>
            <p class="__meetdname">Daily stand-ups, cross-time-zone sprints and weekly demos kept synergy high between Lagos and London.</p>
            
            <p class="__headin">Services Offered</p>
            <ul class="__portp2new">
                <li>AI-assisted talent search</li>
                <li>Pre-vetted developer pool access</li>
                <li>Node.js backend expertise</li>
                <li>Cross-platform mobile dev</li>
                <li>Full QA support</li>
                <li>End-to-end onboarding & payroll coordination</li>
            </ul>

            <p class="__headin">Results / Impact Tiles</p>
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Time to Hire</span></p>
                        <p class="__meetdname">< 2 weeks</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Candidate Fit</span></p>
                        <p class="__meetdname">00 % accepted</p>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <div class="__card1">
                        <p class="__meetdname"><span class="__namp">Bug Reduction</span></p>
                        <p class="__meetdname">30 % fewer defects</p>
                    </div>
                </div>
            </div><br>

            <p class="__meetdname">From 2022–2023 our engineers stabilised Pillar’s core infrastructure, improved user retention through faster, cleaner mobile builds and automated key QA pipelines. Two engineers so impressed the team that Pillar sponsored their relocation to the UK.</p>

            <p class="__headin">Tech Stack Deployed</p>
            <ul class="__portp2new">
                <li>Node.js</li>
                <li>Flutter</li>
                <li>PostgreSQL</li>
                <li>AWS</li>
                <li>Cypress (QA)</li>
            </ul>

            <p class="__headin">Client Testimonial</p>
            <p class="__meetdname">“Findworka’s engineers didn’t just ‘fit in,’ they helped us grow faster and smarter. We’re proud to now have two of them working full-time from the UK.” <span class="__namp"><i> — Engineering Lead, Pillar</i></span></p>

            <div class="row">
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
                <div class="col-xl-8 col-lg-8 col-md-8 col-12">
                    <div class="text-center">
                        <p class="__hvsip">Need top-tier developers reliably and quickly?</p>
                        <p class="__meetdname">Tell us about the roles you’re hiring for, and receive pre-vetted profiles in under 72 hours. Whether you’re looking for individuals or building a team, you’ve come to the right place.</p>
                        <router-link to="/hire" class="btn __viewsite">Get Started Here </router-link>
                    </div>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-2 col-12"></div>
            </div>

            <div class="__whitespace"></div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';

export default {
    components: { navbar },
    data(){
        return{}
    },
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/talentpillar.vue